<template>
  <div class="app-structure-component">

    <div class="section__controls" v-if="app.status==='NEW' && hasPermission('api.application.profile.setStructure')">
      <button class="btn btn--main btn--sm" @click="searchStructure">{{ getTranslation('chooseStructure') }}</button>
    </div>

    <div v-if="app.testingStructure" class="section__header-left">
      <router-link :to="{name:'api.testing.structure.get',params: {id:app.testingStructure.id}}">{{ app.testingStructure.title }}</router-link>
    </div>

    <table class="table  table--noborder mt-4" v-if="app.testingStructure">
      <thead class="table__head">
        <tr class="table__row">
          <th class="table__cell  table__hcell" style="width: 20%;">{{ getTranslation('naming') }}</th>
          <th class="table__cell  table__hcell" style="width: 20%;">{{ getTranslation('questionsCount') }}</th>
          <th class="table__cell  table__hcell" style="width: 20%;">{{ getTranslation('duration') }}</th>
          <th class="table__cell  table__hcell" style="width: 20%;">{{ getTranslation('minimalPoint') }}</th>
        </tr>
      </thead>

      <tbody class="table__body">
        <tr class="table__row" v-for="item in app.testingStructure.tests" v-bind:key="item.id">
          <td class="table__cell">{{ item.testType.titleRu }}</td>

          <td class="table__cell">{{ item.questionCount }}</td>

          <td class="table__cell">{{ item.duration }}</td>

          <td class="table__cell">{{ item.minimalPoint }}&#37;</td>
        </tr>
      </tbody>
    </table>
    <table v-else class="table  table--noborder">
      <tr class="table__row">
        <td class="table__cell empty">
          {{ getTranslation('notAddedYet') }}
        </td>
      </tr>
    </table>

    <modal
        v-model="showModal"
        :modal-title="getTranslation('chooseStructure')"
    >
      <section class="tabs-2">

        <ul class="nav  tabs-2__nav  tabs-2__hor-nav">
          <li class="tabs-2__nav-item" @click="tabSelect('suitable')">
            <a class="tabs-2__nav-link" :class="{'active':tabs.suitable}" href="javascript:void(0)">{{ getTranslation('suitableStructures') }}</a>
          </li>
          <li class="tabs-2__nav-item" @click="getAllStructure">
            <a class="tabs-2__nav-link" :class="{'active':tabs.all}" href="javascript:void(0)">{{ getTranslation('allStructures') }}</a>
          </li>
        </ul>


        <div class="tabs-2__content">

          <div class="tabs-2__pane" :class="{'active':tabs.suitable}">
            <table class="table-3 table-borderless" v-if="structures.length > 0">
              <thead class="table-3__head">
                <tr class="table-3__row">
                  <th class="table-3__cell  table__hcell">
                    {{ getTranslation('title') }}
                  </th>
                  <th class="table-3__cell  table__hcell">

                  </th>
                </tr>
              </thead>
              <tbody class="table-3__body">
                <tr v-for="item in structures" v-bind:key="item.id" class="table-3__row">
                  <td class="table-3__cell">
                    {{ item.title }}
                  </td>
                  <td class="table-3__cell">
                    <a @click="setStructure(item)" class="btn btn--sm btn--main text-white">
                      {{ getTranslation('chooseStructure') }}
                    </a>
                  </td>

                </tr>
              </tbody>
            </table>
            <table v-else class="table  table--noborder">
              <tr class="table__row">
                <td class="table__cell empty">
                  {{ getTranslation('notAddedYet') }}
                </td>
              </tr>
            </table>
          </div>

          <div class="tabs-2__pane allStructure" :class="{'active':tabs.all}">
            <table class="table-3 table-borderless">
              <thead class="table-3__head">
                <tr class="table-3__row">
                  <td colspan="2" class="table-3__cell">
                    <form @submit.prevent="getAllStructure">
                      <div class="field-advanced">
                        <div class="field-advanced__inner">
                          <div class="field-advanced__field-wrap">
                            <input :placeholder="getTranslation('title')" class="field  field--full-width  field--bg-grey  js-borderOnFocus" v-model="filterForm.query" type="text">
                          </div>

                          <div class="field-advanced__right">
                            <button class="btn  btn--square  btn--main">
                              <svg class="btn__icon">
                                <use xlink:href="#icon__search"></use>
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </td>

                </tr>
                <tr class="table-3__row">
                  <th class="table-3__cell  table__hcell">
                    {{ getTranslation('title') }}
                  </th>
                  <th class="table-3__cell  table__hcell">

                  </th>
                </tr>
              </thead>
              <tbody class="table-3__body">
                <tr v-for="item in items" v-bind:key="item.id" class="table-3__row">
                  <td class="table-3__cell">
                    {{ item.title }}
                  </td>
                  <td class="table-3__cell">
                    <a @click="setStructure(item)" class="btn btn--sm btn--main text-white">
                      {{ getTranslation('chooseStructure') }}
                    </a>
                  </td>

                </tr>
                <tr v-if="items.length < 1" class="table__row">
                  <td class="table__cell empty">
                    {{ getTranslation('noResults') }}
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="page-layout__pagination" v-if="pagination.total && pagination.lastPage > 1">
              <pagination :pagination="pagination" @change="()=>{this.getAllStructure();this.$scrollTo('.allStructure');}" v-model="filterForm.page"></pagination>
            </div>
          </div>

        </div>
        <!-- /tabs-2__content -->

      </section>

    </modal>
  </div>
</template>

<script>
import applicationMixin from '@/views/admin/applications/mixins/application';

export default {
  name: 'ApplicationStructureComponent',
  props: [ 'appId', 'app' ],
  mixins: [ applicationMixin ],
  data() {
    return {
      structures: [],
      items: [],
      structureTests: [],
      tabs: {
        suitable: true,
        all: false,
      },
      showModal: false,
      pagination: {
        total: '',
        lastPage: '',
        currentPage: '',
      },
    };
  },
  methods: {
    getAllStructure() {
      this.filterForm = this.cleanObject(this.filterForm);
      this.filterForm.status = true;
      this.filterForm.count = 10;
      this.axios.get(this.$config.urls.structure.fetchTestingStructures.url, { params: this.filterForm }).then(response => {

        this.items = response.data.data.items;
        this.pagination.currentPage = response.data.data.activePage;
        this.filterForm.page = response.data.data.activePage;
        this.pagination.total = response.data.data.totalItemsCount;
        this.pagination.lastPage = response.data.data.pages;

      }).catch(() => {}).finally(() => {

        this.tabSelect('all');

      });

      this.tabSelect('all');
    },
    searchStructure() {
      this.showModal = true;
      this.tabSelect('suitable');
      this.filterForm.query = '';
      this.fetchSuitableStructures();
    },
    fetchSuitableStructures() {
      return this.axios.get(this.$config.urls.application.fetchSuitableStructures.url.replace(':id', this.appId)).then(response => {
        this.structures = response.data.data;
      }).catch(() => {});
    },
    setStructure( item ) {
      return this.axios.post(this.$config.urls.application.setStructure.url.replace(':id', this.appId), {
        structureId: item.id,
      }).then(response => {
        this.showModal = false;

        this.app.testingStructure = response.data.data;

        this.snotifySuccess('saveSuccessMsg');
      }).catch(() => {});
    },
  },
};
</script>

<style scoped>

</style>
